module.exports = __webpack_public_path__ + "static/media/le-parisien.0c8419b8.svg";